<template>
  <v-dialog v-model="dialog" max-width="400px">
    <template v-slot:activator="{ on }">
      <v-btn color="primary" v-on="on">
        <v-icon small left>mdi-plus</v-icon>
        Add a supplier
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Add a supplier</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-alert type="error" v-if="errorMessage">
          <span v-html="errorMessage"></span>
        </v-alert>
        <v-container>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                label="Name"
                v-model="item.name"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Country"
                v-model="item.country"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Currency"
                v-model="item.currency"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                type="number"
                label="Exchange Rate"
                v-model="item.exchangeRate"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                :items="connectors.map((connector, index) => ({ value: index, text: connector.name }))"
                label="Connector"
                v-model="connectorSelected"
              ></v-select>
            </v-col>
            <v-col cols="12" v-if="Object.keys(parameters).length > 0">
              <h3>API Parameters</h3>
              <v-divider></v-divider>
              <v-container class="pa-0">
                <v-row>
                  <v-col cols="12" md="6" v-for="(element, key) in parameters" :key="key">
                    <v-text-field
                      :label="key"
                      v-model="parameters[key]"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="resetDialog">Reset</v-btn>
        <v-btn color="primary" text :loading="loading" @click="createItem">Add</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data: () => ({
    dialog: false,
    loading: false,
    item: {
      name: '',
      country: '',
      currency: '',
      exchangeRate: 1
    },
    errorMessage: '',
    connectorSelected: null,
    parameters: {}
  }),
  computed: {
    ...mapState(['connectors'])
  },
  watch: {
    connectorSelected () {
      if (this.connectorSelected === null) {
        this.parameters = {}
      } else {
        this.parameters = this.connectors[this.connectorSelected].parameters
      }
    }
  },
  methods: {
    createItem () {
      this.loading = true
      this.errorMessage = ''
      this.$http.post(
        this.$directory + '/suppliers',
        {
          name: this.item.name,
          country: this.item.country,
          currency: this.item.currency,
          exchangeRate: parseFloat(this.item.exchangeRate),
          allowAsyncRequests: true,
          delayToRequest: false,
          connector: this.connectorSelected === null ? '' : this.connectors[this.connectorSelected].name,
          parameters: this.connectorSelected === null ? {} : this.parameters
        }
      )
        .then(() => {
          this.dialog = false
          this.resetDialog()
          this.$emit('refresh')
        })
        .catch(error => {
          if (!error.response) {
            this.errorMessage = error.message
          } else {
            this.errorMessage = error.response.data['hydra:description'].replace(/\n/g, '<br/>')
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    resetDialog () {
      this.item = {
        name: '',
        country: '',
        currency: '',
        exchangeRate: 1
      }
      this.connectorSelected = null
      this.loading = false
      this.errorMessage = ''
    }
  }
}
</script>
